/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import path from 'path';

/**
 * Takes a full filepath, and returns the name of the file without the file
 * extension.
 * @param {string} fp a full file path
 * @returns {string} the filename without
 * @example
 *
 * getFileRoot(C:/Documents/MyDocument.pdf)
 * -> 'MyDocument'
 */
export default function getFileRoot(fp) {
  return path.basename(fp, path.extname(fp));
}
